// extracted by mini-css-extract-plugin
export var active = "navbar-module--active--KqUjy";
export var navbarContainer = "navbar-module--navbarContainer--YsatZ";
export var navbarLink = "navbar-module--navbarLink--opTwp";
export var navbarLinks = "navbar-module--navbarLinks--K9UbU";
export var navbarLogo = "navbar-module--navbarLogo--hhqmX";